import EddyEmbed from './EddyEmbed';

export default EddyEmbed;
export * from './types';
